const getTimestamp = (time: string) => {
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
  }
  let formattedTime = new Date(time)
    .toLocaleString('en-US', options)
    .replace(' at ', ', ')
  if (formattedTime.includes(' 24:')) {
    formattedTime = formattedTime.replace(' 24:', ' 00:')
  }
  return formattedTime
}

export default getTimestamp
